import '../styles/DocumentMiniature.css'

const DocumentMiniature = ({ type, side, isActive }) => {
  const isFront = side === 'Frente'

  return (
    <div className={`doc-miniature ${isActive ? 'active' : 'inactive'}`}>
      {/* Card visual do documento */}
      <div className="doc-mini-card">
        {isFront ? (
          <>
            {/* Frente - com foto, brasão e campos */}
            <div className="doc-mini-header-bar">
              <div className="doc-mini-brasao"></div>
              <div className="doc-mini-title-small">REPÚBLICA FEDERATIVA DO BRASIL</div>
            </div>

            <div className="doc-mini-content">
              <div className="doc-mini-photo-box"></div>
              <div className="doc-mini-fields">
                <div className="doc-field"></div>
                <div className="doc-field"></div>
                <div className="doc-field short"></div>
              </div>
            </div>
          </>
        ) : (
          <>
            {/* Verso - apenas campos de texto */}
            <div className="doc-mini-back-content">
              <div className="doc-field-back"></div>
              <div className="doc-field-back"></div>
              <div className="doc-field-back short"></div>
              <div className="doc-field-back"></div>
            </div>
          </>
        )}
      </div>

      {/* Label abaixo */}
      <div className="doc-mini-label">{side.toUpperCase()}</div>
    </div>
  )
}

export default DocumentMiniature
